"use client"
import { useMemo } from "react"
import { type PowerRegionData } from "../../../../power-bubble-chart/powerBubbleChartData"
import { useHudContext } from "../../../shared/playbookHUDInfra"
import { getBranchPowerRegions } from "./branchPowerRegions"
import { getPlanAPowerRegions } from "./planAPowerRegions"

// Shared data source for every distribution-of-power variant: Plan A (and all
// pre-choice-point story dates) reads the bundled power-distribution tab
// import (data/plan-a/powerDistribution.json via getPlanAPowerRegions);
// branch plans read their own generated concentration data. Keeping this in
// one hook means the treemap and the columns strip render identical
// proportions.
export const usePowerRegions = (): PowerRegionData[] => {
  const ctx = useHudContext()

  // Branch data only applies once the reader has actually picked a plan (or
  // is hover-previewing one). ctx.activePlan is unsuitable here: it falls
  // back to "D" above the choice point, which would render plan D's branch
  // table — clamped to its first date, 2029.1, with every named entity
  // frontier — on pre-split story dates. ctx.selectedPlan is nulled while
  // the reader is above the choice point, so gating on it keeps the
  // pre-split view on the Plan A data.
  const branchPlan = ctx.hoveredPlan ?? ctx.selectedPlan
  return useMemo(
    () => getBranchPowerRegions(branchPlan, ctx.year) ?? getPlanAPowerRegions(ctx.powerColumnDate),
    [ctx.year, ctx.powerColumnDate, branchPlan],
  )
}
